import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ui-section',
  templateUrl: './ui-section.component.html',
  styleUrl: './ui-section.component.scss',
  imports: [TranslateModule],
  host: { '[class.separator]': 'separator()' },
})
export class UiSectionComponent {
  public readonly title = input<string>();
  public readonly removeLabel = input<string | null>(null);
  public readonly separator = input<boolean>(false);

  public readonly onRemove = output<PointerEvent>();
}

